import React, { createContext, useContext, useState } from 'react';

const AnalyticsContext = createContext();

export const AnalyticsProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    sentSurveyId: null,
    // Périmètre exposé dans la FilterBar — source unique de la dimension
    // d'Analyse détaillée (voir components/Analytics/scopeRouting.js).
    // 'global' = aucun filtrage par segment (comportement par défaut).
    scope: 'global',
    scopeValue: null,
  });

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  return (
    <AnalyticsContext.Provider value={{ filters, updateFilter }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
